<template>
  <section class="top-bar">
    <div v-if="temImagem" @click="abrirImagem(imagem)">
      <img src="../../assets/icons/ic-maximizar.png" class="botao-maximizar-minimizar" alt="">
      <img id="mercadoriaImg" :src="imagem || ''" alt="mercadoria" @error="onErrorImagem" ref="imagemzinha"/>
    </div>
    <div v-if="imagemEmEvidencia" class="evidencia" @click="fecharImagem()">
      <img src="../../assets/icons/ic-minimizar.png" class="botao-maximizar-minimizar" alt="">
      <img :src="imagemEmEvidencia" class="imagem-ampliada" />
    </div>
    <div :class="temImagem ? 'titulo-descricao' : 'titulo-descricao-sem-imagem'">
      <h2 class="titulo">{{ this.titulo }}</h2>
      <p class="descricao" v-if="this.descricao != null && this.descricao != ''">{{ this.descricao }}</p>
    </div>
  </section>
</template>

<script>
export default {
  name: "TopBar",
  props: {
    imagem: String,
    titulo: String,
    descricao: String,
  },
  data() {
    return {
      temImagem: true,
      imagemEmEvidencia:null,
    };
  },
  computed: {},
  methods: {
    //Evidencia a foto do item quando clicada
    abrirImagem(src){
      this.imagemEmEvidencia= src;
    },
    //Tira a evidencia da foto do item quando o cliente clica em qualquer lugar da tela.
    fecharImagem(){
      this.imagemEmEvidencia=null;
    },
    /**
     * caso a url da imagem nao esteja funcionando, deve entao usar  a fallback image i-c-camera.png dos assets
     */
    onErrorImagem() {
      this.temImagem = false;
      this.$refs.imagemzinha.src = require(`../../assets/icons/ic-camera.png`);
    },
  },
};
</script>

<style scoped>
.evidencia {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.imagem-ampliada {
  max-width: 100%;
  max-height: 100%;
  border-radius: 10px;
  box-shadow: 0 0 20px #000;
  cursor: pointer;
}
.botao-maximizar-minimizar{
  position:absolute;
  top: var(--padding-padrao-pequeno);
  left: var(--padding-padrao-pequeno);
  width: 40px;
  background: whitesmoke;
  border-radius: 10px;
}
.top-bar {
  margin: 0;
  background: black;
  color: white;
}

/* mobiles  */
@media only screen and (max-width: 720px) {
  #mercadoriaImg {
    margin: 0;
    width: 100%;
    aspect-ratio: 1.5;
    object-fit: cover;
  }
}

/* desktops */
@media only screen and (min-width: 720px) {
  #mercadoriaImg {
    margin: 0;
    width: 40%;
    aspect-ratio: 1.5;
    object-fit: cover;
  }
}

#nomeDaMercadoria {
  width: 100%;
  background: black;
  font-size: 18px;
  padding-block: 15px;
  margin: 0;
  margin-top: -4px;
  word-wrap: normal;
}
.titulo-descricao {
  padding-block: 10px;
  margin: 0;
}

.titulo-descricao-sem-imagem {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 45px;
  background: black;
  padding-top: 50px;
  padding-bottom: 30px;
  padding-inline: 10px;
}

.titulo {
  margin: 0px;
}
.descricao {
  overflow-wrap: break-word;
  margin-top: 10px;
  font-size: 14px;
  padding-inline: 5%;
  text-align: justify;
  font-size: 0.8rem;
}
</style>
